import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { RewardStickerComponent } from '@shared/components/challenges/elements/reward-sticker/reward-sticker.component';
import { SubType } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { SelectionButtonSecondVariantConfig } from '@shared/models';
import { VariableReplacementPipe } from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [ButtonComponent, RewardStickerComponent, VariableReplacementPipe],
})
export class Variant2Component extends SelectionButtonBaseClass {
  config = input.required<SelectionButtonSecondVariantConfig>();
  // Resolved by the challenge card: sub type designs only apply to bonus campaigns
  subType = input<SubType>(SubType.DEFAULT);
}
